export default __webpack_public_path__ + "static/media/spookyswap.32152969.svg";